import React, { memo } from 'react';
import { useFormField } from 'formydable';
const States = /*#__PURE__*/memo(({
  children
}) => {
  const {
    formState
  } = useFormField();
  const states = formState();
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(states));
});
export default States;